import { defineComponent as _defineComponent } from 'vue'
import VsText from '@/components/vision/VsText.vue'
import { startCase } from 'lodash'
import { computed } from 'vue'

type ChipType = {
  id: number | string | null
  title: string | null
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AutoCompleteChips',
  props: {
    chips: null,
    maximumChips: null,
    disabled: { type: Boolean },
    small: { type: Boolean }
  },
  emits: ["remove:chip"],
  setup(__props: any, { emit }: { emit: ({ (event: 'remove:chip', value: ChipType): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  chips: ChipType[]
  maximumChips?: number
  disabled?: boolean
  small?: boolean
}





const displayedChips = computed(() => {
  return props.chips.slice(0, props.maximumChips).map((c) => ({
    id: c.id,
    title: c.title || '',
  }))
})

const numberOverflowChips = computed(() => {
  if (props.maximumChips) {
    return props.chips.length - props.maximumChips
  }
  return 0
})

return { __sfc: true,props, emit, displayedChips, numberOverflowChips, VsText, startCase }
}

})